<template>
    <dl :class="$style.viewbox">
        <dt><img src="@assets/images/users/user-multiple.svg" /></dt>
        <dd>
            <div :class="$style.container">
                <div :class="$style.item">
                    <div :class="$style.label">
                        <span>{{ $t('user_setting.total_users') }}</span>
                        <el-tooltip>
                            <template #content>
                                <div style="max-width: 400px" v-html="$t('user_setting.total_users_tip')"></div>
                            </template>
                            <pt-icon icon="pt-icon--help-new"></pt-icon>
                        </el-tooltip>
                    </div>
                    <span :class="$style.pending" v-if="loading">
                        {{ $t('user_setting.fetching_data') }}
                    </span>
                    <span v-else :class="$style.number">
                        {{ visibleTotalUsers }}
                    </span>
                </div>
                <span :class="$style.separator"></span>
                <div :class="$style.item">
                    <div :class="$style.label">
                        <span>{{ $t('user_setting.active_users') }}</span>
                        <el-tooltip>
                            <template #content>
                                <div style="max-width: 400px" v-html="$t('user_setting.active_users_tip')"></div>
                            </template>
                            <pt-icon icon="pt-icon--help-new"></pt-icon>
                        </el-tooltip>
                    </div>
                    <span :class="$style.pending" v-if="loading">
                        {{ $t('user_setting.fetching_data') }}
                    </span>
                    <span v-else :class="$style.number">
                        {{ visibleActiveUsers }}
                    </span>
                </div>
            </div>
        </dd>
    </dl>
</template>

<script>
export default {
    name: 'UsersData',
    props: {
        visibleOverview: Boolean,
        users: String,
        activeUsers: String,
        loading: Boolean
    },
    computed: {
        visibleTotalUsers() {
            return this.users ?? '--';
        },

        visibleActiveUsers() {
            return this.activeUsers ?? '--';
        }
    }
};
</script>

<style lang="scss" module>
@import '@/styles/import.scss';

.viewbox {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 14px 20px;
    background-color: $pt-success-hover;
    border: 1px solid $pt-green-10;
    border-radius: 3px;
    margin: 12px 0;

    dt {
        flex-shrink: 0;

        img {
            width: 20px;
            height: 20px;
        }
    }

    dd {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .container {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .note {
        font-size: 12px;
        color: $pt-black-300;
    }

    .item {
        height: 24px;
        display: flex;
        gap: 8px;
        align-items: center;
        color: $pt-black-900;

        .label {
            font-size: 14px;
            display: flex;
            align-items: center;
            gap: 4px;

            svg {
                width: 14px !important;
                height: 14px !important;
                fill: $pt-black-90;
            }
        }

        .number {
            font-size: 20px;
        }

        .pending {
            font-size: 14px;
            color: $pt-black-60;
        }
    }

    .separator {
        height: 16px;
        width: 1px;
        background-color: $pt-black-50;
        display: block;
    }
}
</style>
